<template>
  <div class="modal-content">
    <button type="button" class="close" @click="$emit('closeModal')">
      <span aria-hidden="true"><svg v-svg symbol="x" size="0 0 17 17"></svg></span>
    </button>
    <div class="modal-body d-flex flex-column align-items-center mt-4">
      <svg width="65" height="76" viewBox="0 0 65 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.107247 48.5893C0.0358189 48.7858 0 49 0 49.2143C0 49.375 0.017892 49.5179 0.0357492 49.6786C0.017892 50.1072 0 50.5536 0 51C0 64.8036 11.1964 76 25 76C38.8036 76 50 64.8036 50 51C50 50.5536 49.9821 50.1072 49.9642 49.6786C49.9821 49.5179 50 49.375 50 49.2143C50 49 49.9642 48.7858 49.8928 48.5893C48.6606 35.9108 38 26 25 26C12 26 1.33939 35.9108 0.107247 48.5893ZM25 29.5714C23.1607 29.5714 20.9286 31.2678 19.0536 35.3393C17.2322 39.25 16.0714 44.7857 16.0714 51C16.0714 51.4643 16.0714 51.9107 16.0893 52.375C18.8036 52.6429 21.8214 52.7857 25 52.7857C28.1786 52.7857 31.1964 52.6429 33.9107 52.375C33.9286 51.9107 33.9286 51.4643 33.9286 51C33.9286 44.7857 32.7678 39.25 30.9464 35.3393C29.0714 31.2678 26.8393 29.5714 25 29.5714ZM33.6785 55.9822C30.9821 56.2322 28.0536 56.3571 25 56.3571C21.9464 56.3571 19.0179 56.2322 16.3215 55.9822C16.7679 60.1429 17.7322 63.8393 19.0536 66.6607C20.9286 70.7322 23.1607 72.4286 25 72.4286C26.8393 72.4286 29.0714 70.7322 30.9464 66.6607C32.2678 63.8393 33.2321 60.1429 33.6785 55.9822ZM12.5 51.9286C12.5 51.625 12.5 51.3036 12.5 51C12.5 44.3929 13.7321 38.3215 15.8035 33.8393C16.2678 32.8215 16.8036 31.8572 17.3928 30.9643C9.85713 33.8215 4.35721 40.8214 3.64293 49.1607C3.78578 49.3035 4.03571 49.5001 4.46429 49.7322C5.42857 50.2679 6.94648 50.7858 8.98219 51.2679C10.0536 51.5 11.2321 51.7322 12.5 51.9286ZM3.69633 53.3215C4.94633 53.8751 6.48206 54.3392 8.17849 54.75C9.55349 55.0535 11.0535 55.3394 12.6964 55.5537C13.125 60.3751 14.2142 64.7321 15.8035 68.1607C16.2678 69.1785 16.8036 70.1428 17.3928 71.0357C9.99998 68.2321 4.57133 61.4644 3.69633 53.3215ZM46.3571 49.1607C45.6428 40.8214 40.1429 33.8215 32.6072 30.9643C33.1964 31.8572 33.7322 32.8215 34.1965 33.8393C36.2679 38.3215 37.5 44.3929 37.5 51C37.5 51.3036 37.5 51.625 37.5 51.9286C38.7679 51.7322 39.9464 51.5 41.0178 51.2679C43.0535 50.7858 44.5714 50.2679 45.5357 49.7322C45.9643 49.5001 46.2142 49.3035 46.3571 49.1607ZM46.3037 53.3215C45.0537 53.8751 43.5179 54.3392 41.8215 54.75C40.4465 55.0535 38.9465 55.3394 37.3036 55.5537C36.875 60.3751 35.7858 64.7321 34.1965 68.1607C33.7322 69.1785 33.1964 70.1428 32.6072 71.0357C40 68.2321 45.4287 61.4644 46.3037 53.3215Z"
          fill="black"
        />
        <circle cx="48" cy="29" r="17" fill="#37807D" />
        <path
          d="M49.0898 32.7852H46.1016C46.1094 32.082 46.1641 31.4766 46.2656 30.9688C46.375 30.4531 46.5586 29.9883 46.8164 29.5742C47.082 29.1602 47.4336 28.75 47.8711 28.3438C48.2383 28.0156 48.5586 27.7031 48.832 27.4062C49.1055 27.1094 49.3203 26.8047 49.4766 26.4922C49.6328 26.1719 49.7109 25.8164 49.7109 25.4258C49.7109 24.9727 49.6406 24.5977 49.5 24.3008C49.3672 23.9961 49.1641 23.7656 48.8906 23.6094C48.625 23.4531 48.2891 23.375 47.8828 23.375C47.5469 23.375 47.2344 23.4492 46.9453 23.5977C46.6562 23.7383 46.418 23.957 46.2305 24.2539C46.0508 24.5508 45.957 24.9414 45.9492 25.4258H42.5508C42.5742 24.3555 42.8203 23.4727 43.2891 22.7773C43.7656 22.0742 44.4023 21.5547 45.1992 21.2188C45.9961 20.875 46.8906 20.7031 47.8828 20.7031C48.9766 20.7031 49.9141 20.8828 50.6953 21.2422C51.4766 21.5938 52.0742 22.1133 52.4883 22.8008C52.9023 23.4805 53.1094 24.3086 53.1094 25.2852C53.1094 25.9648 52.9766 26.5703 52.7109 27.1016C52.4453 27.625 52.0977 28.1133 51.668 28.5664C51.2383 29.0195 50.7656 29.4883 50.25 29.9727C49.8047 30.3711 49.5 30.7891 49.3359 31.2266C49.1797 31.6641 49.0977 32.1836 49.0898 32.7852ZM45.75 36.4062C45.75 35.9062 45.9219 35.4922 46.2656 35.1641C46.6094 34.8281 47.0703 34.6602 47.6484 34.6602C48.2188 34.6602 48.6758 34.8281 49.0195 35.1641C49.3711 35.4922 49.5469 35.9062 49.5469 36.4062C49.5469 36.8906 49.3711 37.3008 49.0195 37.6367C48.6758 37.9727 48.2188 38.1406 47.6484 38.1406C47.0703 38.1406 46.6094 37.9727 46.2656 37.6367C45.9219 37.3008 45.75 36.8906 45.75 36.4062Z"
          fill="white"
        />
      </svg>

      <template>
        <div class="domain-text mt-4">
          {{ $t("domain.buy_domain_modal.modal_text_1") }}
        </div>
        <div class="domain-text domain-seconrady mb-4">
          {{ $t("domain.buy_domain_modal.modal_text_2") }}
          <span class="domain-price">{{ currentDomain.price }}$</span>
        </div>

        <button @click="buyDomain" class="btn mb-2 _mob100 _bg-green mt-4" :disabled="isLoading">
          <img v-if="isLoading" src="@/assets/images/rolling-button.svg" class="loader-button" alt="loader" />
          {{ $t("domain.buy_domain_modal.modal_btn") }}
        </button>

        <div class="domain-info mt-4">
          <svg v-svg symbol="info" size="0 0 17 17" role="info"></svg>
          {{ $t("domain.buy_domain_modal.modal_info") }}
        </div>
      </template>
    </div>
    <alert v-if="$alert.title" />
  </div>
</template>
<script>
import serviceDomain from "@/api/serviceDomain";
import { mapActions } from "vuex";

export default {
  name: "ConfirmDomain",
  props: {
    domainType: {
      type: String,
      default: "",
    },
    currentDomain: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    ...mapActions({
      setUser: "user/setUser",
    }),
    buyDomain() {
      this.isLoading = true;

      const params = {
        category: this.domainType,
        domain_zone: this.currentDomain.zone,
      };
      serviceDomain
        .buyDomain(params)
        .then((res) => {
          if (res && res.status === 200) {
            this.setUser();
            this.$emit("refresh");
            this.$emit("success");
          } else if (res && res.status === 400) {
            this.$alert({
              title: res.message,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.$emit("closeModal");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 23px 40px 50px;

  .btn {
    min-width: 162px;
  }
}

.domain-text {
  color: #141414;
  font-size: 28px;
  font-weight: 700;
  line-height: 2.1;
  text-align: center;

  &.no-domain {
    font-size: 24px;
    line-height: 1.6;
  }
}

.domain-seconrady {
  background: rgba(233, 242, 242, 0.65);
  border-radius: 10px;
  padding: 0 32px;
  text-align: center;
}

.domain-info {
  display: flex;
  align-items: center;
  gap: 0 10px;
  color: #375b5b;
  font-size: 16px;
  line-height: 1.5;

  svg {
    fill: #375b5b;
  }
}

.domain-price,
.green-text {
  color: #37807d;
}
</style>
